<template>
    <q-layout view="hhH LPR lFr">
        <q-page-container>
            <router-view></router-view>
        </q-page-container>
    </q-layout>
</template>

<script>
    import Vue from 'vue'
    import UUID from 'uuid/v4'

    Vue.prototype.$uuid = UUID

    export default {
        name: 'App',
        components: {},
        data () {
            return {}
        },
        mounted () {
            this.$store.dispatch('checkAuth')

            if (this.isLoggedIn) {
                this.fetchAll()
            }
        },
        methods: {
            fetchAll () {
                this.$store.dispatch('fetchAll', {
                    what: 'pole',
                    showDeleted: true
                })

                this.$store.dispatch('fetchAll', {
                    what: 'file'
                })

                this.$store.dispatch('fetchAll', {
                    what: 'badge'
                })

                this.$store.dispatch('fetchAll', {
                    what: 'article'
                })

                this.$store.dispatch('fetchAll', {
                    what: 'survey'
                })

                this.$store.dispatch('fetchAll', {
                    what: 'optionalTask'
                })

                this.$store.dispatch('fetchAll', {
                    what: 'category'
                })

                this.$store.dispatch('fetchAll', {
                    what: 'kbCategory'
                })

                this.$store.dispatch('fetchAll', {
                    what: 'activity'
                })

                this.$store.dispatch('fetchAll', {
                    what: 'achievement'
                })
            },
        },
        computed: {
            loggedIn () {
                return this.$store.state.loggedIn
            },
            env() {
                return process.env
            },
            notifications () {
                return this.$store.state.notifications
            }
        },
        watch: {
            loggedIn (isLoggedIn) {
                if (!isLoggedIn) {
                    this.$router.push({name: 'login'})
                } else {
                    this.fetchAll()
                }
            },
            notifications (nn) {
                if (nn && nn.length) {
                    nn.forEach(n => {
                        this.$q.notify(n)
                    })

                    nn.forEach(n => {
                        this.$store.commit('consumeNotification', n.id)
                    })
                }
            }
        },
    }
</script>
